import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { guestLogin } from "../../../services/auth";
import { useTranslation } from "react-i18next";

export default function LogOut({ setOpenLogOut, setUser }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [setCookie, removeCookie] = useCookies(["access_token"]);
  const handleLogOut = () => {
    removeCookie("access_token");
    setUser(null);
    guestLogin().then((res) =>
      setCookie("access_token", res?.data?.access_token, { path: "/" })
    );
    setOpenLogOut(false);
    navigate("/");
  };
  return (
    <div className="log-out-wrapper">
      <div className="log-out-popup">
        <div
          className="close-button"
          onClick={() => {
            setOpenLogOut(false);
          }}
        ></div>
        <div className="content">
          <div className="title">
            <p>{t("log-out")}</p>
          </div>
          <div className="question">
            <p>{t("log-out-confirm")}</p>
          </div>
        </div>
        <div className="buttons">
          <button className="border" onClick={handleLogOut}>
            {t("log-out")}
          </button>
          <button
            onClick={() => {
              setOpenLogOut(false);
            }}
          >
            {t("close")}
          </button>
        </div>
      </div>
    </div>
  );
}
